var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__text"},[_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'privacy' }}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'terms-of-service' }}},[_vm._v("Terms of Service")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c53e46c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TheFooter.vue
// module id = 433
// module chunks = 1